module.exports = __webpack_public_path__ + "static/media/LHInSwing.e0ae0165.svg";